<template>
	<!-- 账单明细表 -->
	<div class="billDetails public_Spacing ">
		<div class="pulbic_oparetionBlock billDetails-filter-card">
			<div class="billDetails-section-head">
				<div>
					<span>筛选条件</span>
					<p>{{ billDetailsRangeText }}</p>
				</div>
				<strong>{{ recordCount }} 条记录</strong>
			</div>
			<div class="public_criteriaRange billDetails-filter-grid">
				<div class="public_singleMenu" v-if="this.userobj.pertb005.pertb005cb00 =='CUS-1'">
					<label class="public_lbSty">客户：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="customer" placeholder="请选择" filterable remote :remote-method="filterCustomer" clearable>
						<el-option v-for="item in filteredCustomerOptions" :label="item.ORMTB410CA00" :value="item.ORMTB410ID">
						</el-option>
					</el-select>
				</div>
				<!-- <div class="public_singleMenu">
					<label class="public_lbSty">流水号：</label>
					<div class="el-select public_optionSty">
						<div class="el-input el-input--suffix">
							<input class="el-input__inner pulic_carNumber" type="text" placeholder="请输入" v-model="carNum"/>
						</div>
					</div>
				</div> -->
				<!-- <div class="public_singleMenu">
					<label class="public_lbSty">变动类型：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="operateValue" placeholder="请选择">
						<el-option v-for="item in operateOptions" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div> -->
				<div class="public_singleMenu">
					<label class="public_lbSty">操作类型：</label>
					<el-select class="public_optionSty dropDown_Define" v-model="numberValue" placeholder="请选择">
						<el-option v-for="item in numberOptions" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div class="public_singleMenu" v-if="this.userobj.pertb005.pertb005cb00 =='CUS-1'">
					<label class="public_lbSty">充值渠道：</label>
					<el-select v-model="RechargetypeValue" placeholder="请选择">
						<el-option v-for="item in RechargetypeOptions" :key="item.SETTB206CA01"
							:label="item.SETTB206CA01" :value="item.SETTB206CA01">
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="public_operatArea">
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowDayActive?'public_dateActive':''"
					@click="getNowDay">当日</span>
				<span class="public_operatArea_yesterday pulic_cursor"
					:class="dateYesterdayActive?'public_dateActive':''" @click="getYesterday">昨天</span>
				<span class="pulic_operatArea_now pulic_cursor" :class="dateNowMonthActive?'public_dateActive':''"
					@click="getNowMonth">当月</span>
				<span class="public_operatArea_yesterday pulic_cursor"
					:class="dateLastMonthActive?'public_dateActive':''" @click="getLastMonth">上月</span>
				<div class="public_operatArea_timePicker pulic_cursor">
					<el-date-picker v-model="date" type="datetimerange" range-separator="至" start-placeholder="开始日"
						end-placeholder="结束日" :picker-options="startDateDisabled" @change="datePickerChange"
						value-format="yyyy-MM-dd HH:mm:ss" class="pulic_cursor">
					</el-date-picker>
				</div>
				<div class="public_operatBtn billDetails-filter-actions">
					<button class="public_saleWater_chaxun pulic_cursor" :class="{'is-loading': tableLoading}" @click="queryClick" v-shiroHiden="solelist"
						id="查询">
						<span class="billDetails-action-icon"><i class="iconfont icon-chaxun"></i></span>
						<span class="billDetails-action-text">{{ billQueryButtonText }}</span>
					</button>
					<el-button class="public_saleWater_daochu pulic_cursor" @click="daochuExport" :loading="loadingBut"
						v-shiroHiden="solelist" id="导出">
						<span class="billDetails-action-icon is-export"><i class="iconfont icon-daochu"></i></span>
						<span class="billDetails-action-text">导出</span>
						<span class="billDetails-action-count" v-if="confirmTxt >0">{{confirmTxt}}</span>
					</el-button>

					<!-- <el-upload class="upload-demo" ref="upload" action="http://192.168.2.104:8081/exc/toExcel/download"
						:on-preview="handlePreview" :on-remove="handleRemove" :on-success="handSuccess"
						:before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed"
						:file-list="fileList">
						<el-button size="small" type="primary">上传</el-button>
					</el-upload> -->

					<!-- <el-button class="public_saleWater_daochu pulic_cursor" @click="" :loading="loadingBut"
						v-shiroHiden="solelist" id="导出"><i class="iconfont icon-daochu"></i>下载对账单
						<span v-if="confirmTxt >0">{{confirmTxt}}</span>
					</el-button> -->
				</div>

			</div>
		</div>
		<div class="billDetails-filter-tags" v-if="billActiveFilterTags.length">
			<span v-for="item in billActiveFilterTags" :key="item.label" class="billDetails-filter-tag">
				<em>{{ item.label }}</em>{{ item.value }}
			</span>
		</div>
		<div v-shiroHiden="solelist" id="统计" class="billDetails-panel billDetails-stat-panel"
			v-loading="tableLoading" element-loading-text="正在更新账单统计..." element-loading-spinner="el-icon-loading" element-loading-custom-class="billDetails-loading-mask">
			<div class="billDetails-section-head billDetails-stat-head">
				<div>
					<span>账单统计</span>
					<p>汇总当前查询范围内的充值、红冲、扣款和退款数据。</p>
				</div>
				<strong>{{ billDetailsTotalCount }} 单</strong>
			</div>
			<div class="pulbic_oparetionBlock public_statisticsInfo">
				<div class="public_statistics billDetails-statistics is-recharge">
					<div class="public_statisticsContent">
						<i class="iconfont icon-chongzhi1"></i>
						<div class="payType">充值</div>
					</div>
					<ul class="billDetails-ul">
						<li class="pulic_statistics_titlt"><span class="totolTitle">总金额(元)</span><span class="Amount">{{czSum}}</span></li>
						<li class="pulic_statistics_titlt"><span class="totolTitle">总单数(单)</span><span class="singular">{{czCount}}</span></li>
					</ul>
				</div>
				<div class="public_statistics billDetails-statistics is-reversal">
					<div class="public_statisticsContent">
						<i class="iconfont icon-hongchong-copy"></i>
						<div class="payType">红冲</div>
					</div>
					<ul class="billDetails-ul">
						<li class="pulic_statistics_titlt"><span class="totolTitle">总金额(元)</span><span class="Amount">{{hcSum}}</span></li>
						<li class="pulic_statistics_titlt"><span class="totolTitle">总单数(单)</span><span class="singular">{{hcCount}}</span></li>
					</ul>
				</div>
				<div class="public_statistics billDetails-statistics is-deduct">
					<div class="public_statisticsContent">
						<i class="iconfont icon-koukuan1"></i>
						<div class="payType">扣款</div>
					</div>
					<ul class="billDetails-ul">
						<li class="pulic_statistics_titlt"><span class="totolTitle">总金额(元)</span><span class="Amount">{{KKSum}}</span></li>
						<li class="pulic_statistics_titlt"><span class="totolTitle">总单数(单)</span><span class="singular">{{KKCount}}</span></li>
					</ul>
				</div>
				<div class="public_statistics billDetails-statistics is-refund">
					<div class="public_statisticsContent">
						<i class="iconfont icon-tuikuan1"></i>
						<div class="payType">退款</div>
					</div>
					<ul class="billDetails-ul">
						<li class="pulic_statistics_titlt"><span class="totolTitle">总金额(元)</span><span class="Amount">{{tkSum}}</span></li>
						<li class="pulic_statistics_titlt"><span class="totolTitle">总单数(单)</span><span class="singular">{{tKCount}}</span></li>
					</ul>
				</div>

			</div>
		</div>
		<!--  -->
		<div class="billDetails-panel billDetails-table-panel">
			<div class="billDetails-table pulbic_table_container pulbic_oparetionBlock"
				v-loading="tableLoading" element-loading-text="正在加载账单流水..." element-loading-spinner="el-icon-loading" element-loading-custom-class="billDetails-loading-mask">
			<div class="billDetails-table-head">
				<div>
					<span>流水明细</span>
					<p>当前展示第 {{ currentPage }} 页，每页 {{ pageSize }} 条</p>
				</div>
				<strong>{{ tableData.length }} / {{ recordCount }}</strong>
			</div>

			<el-table :data="tableData" style="width: 100%;"
				:default-sort="{prop: 'waterNum', order: 'descending'}" stripe
				:header-cell-style="{color:'rgba(51,51,51,1)','font-weight':'bold'}" class="public_tableColumn billDetails-flow-table is-relaxed">
				<el-table-column prop="ORMTB420CA07" sortable label="账单信息" :min-width="billInfoColumnWidth">
					<template slot-scope="scope">
						<div class="billDetails-main-cell is-relaxed">
							<strong>{{scope.row.ORMTB410CA00 || '-'}}</strong>
							<span>{{scope.row.ORMTB420CA07 || '-'}}</span>
							<em>{{scope.row.ORMTB410CA02 || '暂无联系方式'}}</em>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="ORMTB420CA00" sortable label="类型" min-width="150">
					<template slot-scope="scope">
						<div class="billDetails-tag-cell is-relaxed">
							<span class="billDetails-type-tag">{{scope.row.ORMTB420CA00 || '-'}}</span>
							<span v-if="userobj.pertb005.pertb005cb00 =='CUS-1'" class="billDetails-channel-tag">{{scope.row.ORMTB411CA04 || '-'}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="ORMTB420CA02" sortable label="金额" :min-width="billMoneyColumnWidth">
					<template slot-scope="scope">
						<div class="billDetails-money-card">
							<div class="billDetails-money-card-main">
								<span>变动金额</span>
								<strong>{{scope.row.ORMTB420CA02}}</strong>
							</div>
							<div class="billDetails-money-card-sub">
								<span>原 {{scope.row.ORMTB420CA03}}</span>
								<span>现 {{scope.row.ORMTB420CA04}}</span>
							</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column v-if="this.userobj.pertb005.pertb005cb00 =='CUS-1'" label="附加信息" :min-width="billExtraColumnWidth">
					<template slot-scope="scope">
						<div class="billDetails-extra-cell">
							<div class="billDetails-extra-row">
								<span>优惠券 {{scope.row.ORMTB420CD00 || 0}}</span>
								<span>补贴 {{scope.row.ORMTB420CD02 || 0}}</span>
							</div>
							<p>{{scope.row.ORMTB420CB01 || '暂无备注'}}</p>
							<em>操作人：{{scope.row.ORMTB420CC01 || '-'}}</em>
						</div>
					</template>
				</el-table-column>
				<!-- <el-table-column v-for='(item,index) in tableHeadList' :width="item.width" :prop="item.prop" :label="item.label"  :key="index"> </el-table-column> -->
				<div slot="empty" class="billDetails-empty">
					<strong>暂无账单流水</strong>
					<span>可以调整客户、操作类型或时间范围后重新查询。</span>
				</div>
			</el-table>
			<div class="pulbic_pagesize">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page.sync="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
					layout="total, sizes, prev, pager, next, jumper" :total="recordCount">
				</el-pagination>
			</div>
			</div>
		</div>

	</div>
</template>

<script>
import customerSearchMixin from '@/mixins/customerSearchMixin'
	import {
		saveAs
	} from 'file-saver';
	const operateOptions = [{
			value: '',
			label: '全部'
		},
		{
			value: 'CW',
			label: '财务'
		},
		{
			value: 'XS',
			label: '线上'
		},
		{
			value: 'XX',
			label: '线下'
		}
	];
	const numberOptions = [{
			value: '',
			label: '全部',
		},
		{

			value: 'CZ',
			label: '充值'
		},
		{

			value: 'KK',
			label: '扣款'
		},
		{

			value: 'TK',
			label: '退款'
		},
		{
		
			value: 'YDWLKK',
			label: '运单物料扣款'
		},
		{
		
			value: 'YFKK',
			label: '运费扣款'
		},
		// {

		// 	value: 'SR',
		// 	label: '运费收入'
		// },
		// {

		// 	value: 'YDKK',
		// 	label: '运费运单扣款'
		// },
		{

			value: 'YK',
			label: '能源金划扣'
		},
		// {

		// 	value: 'QX ',
		// 	label: '运单补偿'
		// },
		// {

		// 	value: 'BC',
		// 	label: '取消扣款'
		// },
		{

			value: 'HC',
			label: '红冲'
		},
		{

			value: 'KKXG',
			label: '补款'
		},
    {
      value: 'YKTX',
      label: '能源金转余额'
    },
	{
      value: 'NYJCZ',
      label: '能源金充值'
    },
	// {
 //      value: 'NYJTX',
 //      label: '能源金提现'
 //    },
	{
		value: 'FPKK',
		label: '发票服务费'
	}
	];
	export default {
  mixins: [customerSearchMixin],
		computed: {
			billInfoColumnWidth() {
				let maxText = '账单信息'
				this.tableData.forEach(item => {
					let text = item.ORMTB410CA00 || item.ORMTB420CA07 || ''
					if (String(text).length > String(maxText).length) maxText = text
				})
				return this.getTextWidth(maxText, 140, 220, 54)
			},
			billMoneyColumnWidth() {
				let maxText = '变动金额'
				this.tableData.forEach(item => {
					let text = item.ORMTB420CA02 || item.ORMTB420CA03 || item.ORMTB420CA04 || ''
					if (String(text).length > String(maxText).length) maxText = text
				})
				return this.getTextWidth(maxText, 170, 230, 96)
			},
			billExtraColumnWidth() {
				let maxText = '附加信息'
				this.tableData.forEach(item => {
					let text = item.ORMTB420CB01 || item.ORMTB420CC01 || ''
					if (String(text).length > String(maxText).length) maxText = text
				})
				return this.getTextWidth(maxText, 170, 230, 74)
			},
			activeFilterCount() {
				let count = 0
				if (this.customer) count += 1
				if (this.numberValue) count += 1
				if (this.RechargetypeValue && this.RechargetypeValue !== '全部') count += 1
				if (this.date && this.date.length === 2) count += 1
				return count
			},
			billDetailsRangeText() {
				if (this.date && this.date.length === 2 && this.date[0] && this.date[1]) {
					return this.date[0] + ' 至 ' + this.date[1]
				}
				return '请选择查询时间范围'
			},
			billDetailsTotalCount() {
				return Number(this.czCount || 0) + Number(this.KKCount || 0) + Number(this.tKCount || 0) + Number(this.hcCount || 0)
			},
			billActiveFilterTags() {
				let tags = []
				if (this.customer) {
					let customer = this.customerOptions.find(item => item.ORMTB410ID === this.customer)
					tags.push({ label: '客户', value: customer ? customer.ORMTB410CA00 : this.customer })
				}
				if (this.numberValue) {
					let type = this.numberOptions.find(item => item.value === this.numberValue)
					tags.push({ label: '操作类型', value: type ? type.label : this.numberValue })
				}
				if (this.RechargetypeValue && this.RechargetypeValue !== '全部') tags.push({ label: '充值渠道', value: this.RechargetypeValue })
				return tags
			},
			billQueryButtonText() {
				return this.tableLoading ? '查询中...' : '查询'
			},
		},
		data() {
			return {
				loadingBut: false,
				tableLoading: false,
				confirmTxt: 0,
				confirmTxtdzd: 0,
				isRefresh: true,
				isRefreshSetInterval: '',
				dialogTableVisible: false,
				isIndeterminate: false,
				quanpDisabled: false,
				date: [],
				dateNowDayActive: false,
				dateYesterdayActive: false,
				dateNowMonthActive: false,
				dateLastMonthActive: false,
				startTime: '',
				endTime: '',
				tableData: [],
				RechargetypeValue: '',
				RechargetypeOptions: [],
				operateOptions: operateOptions,
				operateValue: '',
				numberOptions: numberOptions,
				numberValue: '',
				filteredCustomerOptions: [],
      customerOptions: [],
				customer: '',
				carNum: '',
				tableHeadSetShow: false,
				zhezhaoShow: false,
				checkAll: true,
				currentPage: 1,
				pageSize: 10,
				recordCount: 1,
				czSum: 0,
				czCount: 0,
				KKSum: 0,
				KKCount: 0,
				tkSum: 0,
				tKCount: 0,
				hcSum: 0,
				hcCount: 0,
				userobj: '',
				tableHeadList: [
					// {
					// 	prop:'ORMTB420CA07',
					// 	label:'时间',
					// },
					// {
					// 	prop:'ORMTB410CA00',
					// 	label:'客户名称',
					// },
					// {
					// 	prop:'ORMTB420CB00',
					// 	label:'流水号',
					// },
					{
						prop: 'ORMTB420CA01',
						label: '变动类型',
					},
					// {
					// 	prop:'beforeMoney',
					// 	label:'在线类型',
					// },
					{
						prop: 'ORMTB420CA00',
						label: '操作类型',
					},
					{
						prop: 'ORMTB420CA03',
						label: '原金额',
					},
					{
						prop: 'ORMTB420CA02',
						label: '金额',
					},
					{
						prop: 'ORMTB420CA04',
						label: '现金额',
					},
					{
						prop: 'ORMTB420CD00',
						label: '优惠券抵扣',
					},
					{
						prop: 'ORMTB420CC01',
						label: '操作人员',
					},
					// {
					// 	prop:'state',
					// 	label:'状态',
					// },
					{
						prop: 'ORMTB420CA06',
						label: '备注',
					},
				],
				currentUrl: this.$route.path,
				historyInfo: '',
				paymentcode: 1, //结算方式
				// 时间限制
				// 限制开始日期不能超过当前日期
				startDateDisabled: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					}
				},

				solelist: [],
				fileList: [],
			}
		},
		created() {
			var list = "";
			if (this.$route.query.mark != "" && this.$route.query.mark != null) {
				list = JSON.parse(sessionStorage.getItem("qpSolelist"));
				this.userobj = JSON.parse(sessionStorage.getItem('qpUobj'));
				this.CD01 = JSON.parse(sessionStorage.getItem('CD01'));
				var objInfo = JSON.parse(sessionStorage.getItem('objInfo'));
				sessionStorage.removeItem('qpSolelist');
				sessionStorage.removeItem('qpUobj');
				sessionStorage.removeItem('CD01');
				sessionStorage.removeItem('objInfo');
				this.customer = objInfo.customer;
				this.carNum = objInfo.carNum;
				this.operateValue = objInfo.operateValue;
				this.RechargetypeValue = objInfo.RechargetypeValue;
				this.numberValue = objInfo.numberValue;
				this.startTime = objInfo.startTime;
				this.endTime = objInfo.endTime;
				this.date = [this.startTime, this.endTime];
				this.customerOptions = objInfo.customerOptions;
				this.dateNowDayActive = objInfo.dateNowDayActive;
				this.dateYesterdayActive = objInfo.dateYesterdayActive;
				this.dateNowMonthActive = objInfo.dateNowMonthActive;
				this.dateLastMonthActive = objInfo.dateLastMonthActive;
				this.quanpDisabled = true;
			} else {
				list = this.$store.state.solelist;
				this.CD01 = this.$store.state.uobj.pertb005.pertb005cd01;
				this.userobj = this.$store.state.uobj;
				this.quanpDisabled = false;
			}
			var path = this.$route.path;
			if (path === "/billDetails") {
				path = "/Home" + path;
			}
			this.solelist = this.$baseAPI.querSoleList(list, path); //获取权限列表
			//获取历史数据信息
			this.historyInfo = JSON.parse(sessionStorage.getItem(this.currentUrl))
			sessionStorage.removeItem(this.currentUrl)
			if (this.historyInfo != null && this.historyInfo != '') {
				this.init()
			}
		},
		mounted() {
			if (this.historyInfo == null && this.$route.query.mark == null) {
				this.getNowDay();
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = true
			}
			this.enterpriceSelect()
			this.$nextTick(() => {
				this.initTableList()
			})

			if (this.userobj.pertb005.pertb005cb00 == 'CUS-1') {
				this.CZTypeQuery()
			}
		},
		beforeDestroy() {
			this.startTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[0]));
			this.endTime = this.dateFtt("yyyy-MM-dd hh:mm:ss", new Date(this.date[1]));
			//卸载前存储历史信息
			var obj = {
				customer: this.customer,
				carNum: this.carNum,
				currentPage: this.currentPage,
				pageSize: this.pageSize,
				operateValue: this.operateValue,
				RechargetypeValue: this.RechargetypeValue,
				numberValue: this.numberValue,
				startTime: this.startTime,
				endTime: this.endTime,
				dateNowDayActive: this.dateNowDayActive,
				dateYesterdayActive: this.dateYesterdayActive,
				dateNowMonthActive: this.dateNowMonthActive,
				dateLastMonthActive: this.dateLastMonthActive,
			}
			sessionStorage.setItem(this.currentUrl, JSON.stringify(obj))
		},
		methods: {
    filterCustomer(query) {
      if (!query) {
        this.filteredCustomerOptions = this.customerOptions.slice(0, 100)
        return
      }
      const q = query.toLowerCase()
      this.filteredCustomerOptions = this.customerOptions.filter(item =>
        (item.ORMTB410CA00 || '').toLowerCase().includes(q) ||
        (item.ORMTB410CA13 || '').toLowerCase().includes(q)
      )
    },
			getTextWidth(text, minWidth, maxWidth, extraWidth) {
				let width = String(text || '').length * 14 + extraWidth
				return Math.max(minWidth, Math.min(maxWidth, width))
			},
			init() { //初始化数据
				this.customer = this.historyInfo.customer
				this.carNum = this.historyInfo.carNum
				this.currentPage = this.historyInfo.currentPage
				this.pageSize = this.historyInfo.pageSize
				this.operateValue = this.historyInfo.operateValue
				this.RechargetypeValue = this.historyInfo.RechargetypeValue
				this.numberValue = this.historyInfo.numberValue
				this.startTime = this.historyInfo.startTime
				this.endTime = this.historyInfo.endTime
				this.date = [this.startTime, this.endTime]
				this.dateNowDayActive = this.historyInfo.dateNowDayActive
				this.dateYesterdayActive = this.historyInfo.dateYesterdayActive
				this.dateNowMonthActive = this.historyInfo.dateNowMonthActive
				this.dateLastMonthActive = this.historyInfo.dateLastMonthActive
			},


			submitUpload() {
				this.$refs.upload.submit();
			},

			//获取客户列表
			enterpriceSelect() {
				this.customerOptions = [{
					ORMTB410CA00: "全部",
					ORMTB410ID: ""
				}];
				// console.log(this.userobj)

				var data = {

				}
				if (this.userobj.pertb005.pertb005cb00 == "CUS-2") {
					data = {
						ORMTB400ID: this.userobj.ormtb410.ORMTB410ID //一级企业id
					}
				}
				if (this.userobj.pertb005.pertb005cb00 == "CUS-1") {
					data = {
						ORMTB400ID: this.userobj.ormtb400.ORMTB400ID //一级企业id
					}
				}

				var url1 = '/orm/ormtb420/selectOrmtb410CA00List'
				this.axios.post(url1, data).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.customerOptions = [...this.customerOptions, ...res.data.data]
          this.filteredCustomerOptions = this.customerOptions.slice(0, 100)
					}
				}).catch(() => {})
			},

			exportHandler(data) {
				let self = this;
				var url1 = '/exc/toExcel/download'
				// let params = {
				// 	name: data.name,
				// 	Id: data.id
				// };
				let formData = new FormData();
				formData.append("file", data.raw);
				//请求接口
				this.axios.post(url1, formData, {
					responseType: 'blob', //定义接口响应的格式,很重要
				}).then(response => {

					let blob = new Blob([response.data]); //response.data为后端传的流文件
					let downloadFilename = data.name + ".xls"; //设置导出的文件名
					if (window.navigator && window.navigator.msSaveOrOpenBlob) {
						//兼容ie浏览器
						window.navigator.msSaveOrOpenBlob(blob, downloadFilename)
					} else {
						//谷歌,火狐等浏览器
						let url = window.URL.createObjectURL(blob);
						let downloadElement = document.createElement("a");
						downloadElement.style.display = "none";
						downloadElement.href = url;
						downloadElement.download = downloadFilename;
						document.body.appendChild(downloadElement);
						downloadElement.click();
						document.body.removeChild(downloadElement);
						window.URL.revokeObjectURL(url);
					}
					self.$message({
						type: "success",
						message: '导出成功！'
					});

				}).catch(err => {
					self.$message({
						type: 'error',
						message: "导出失败！"
					});
				})
			},


			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handSuccess(res, file, fileList) {
				console.log(res)
				console.log(file)
				this.exportHandler(file)
				// 接口调用成功后文件下载
				// let contentType = res.headers['content-type']
				// let contentDisposition = res.headers['content-disposition']
				// if (contentType.indexOf('application/json') !== -1) {}
				// else {
				// contentDisposition = contentDisposition.split(';')[1]
				// let filename = contentDisposition.split('=')[1]
				// let filenameStr = window.decodeURI(filename.split(',')[0], 'utf-8')
				// const blob = new Blob([res.data], {
				// 	type: 'application/vnd.ms-excel'
				// })
				// const link = document.createElement('a')
				// const href = window.URL.createObjectURL(blob)
				// // 后台在header中传文件名
				// link.href = href
				// // link.download = filenameStr
				// document.body.appendChild(link)
				// link.click()
				// document.body.removeChild(link) // 下载完成移除元素
				// window.URL.revokeObjectURL(href) // 释放掉blob对象
				// }

			},
			handlePreview(file) {
				console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${ file.name }？`);
			},

				initTableList() {

					this.tableLoading = true
				var ORMTB400ID
				if (this.userobj.pertb005.pertb005cb00 == "CUS-2") {
					this.customer = this.userobj.ormtb410.ORMTB410ID //一级企业id
					ORMTB400ID = ''
				}
				if (this.userobj.pertb005.pertb005cb00 == "CUS-1") {
					this.customer = this.customer
					ORMTB400ID = this.userobj.ormtb400.ORMTB400ID //一级企业id

				}
				// console.log(this.RechargetypeValue)
				if (this.RechargetypeValue == '全部') {
					this.RechargetypeValue = ''
				}
				var postData = {
					page: this.currentPage,
					limit: this.pageSize, //代码类型
					ORMTB410ID: this.customer, //客户名称
					ORMTB400ID: ORMTB400ID, //流水号
					ORMTB420CA00: this.numberValue, //操作类型
					ORMTB420CA01: this.operateValue, //变动类型
					ORMTB411CA04: this.RechargetypeValue, //充值渠道
					startTime: this.startTime, //开始时间
					endTime: this.endTime, //结束时间
				}
				var url = "/orm/ormtb420/selectPageList";
				this.axios.post(url, postData).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.tableData = res.data.data.ormtb400PageList;
						if (res.data.data.KK) {
							this.KKCount = res.data.data.KK.COUNT || 0;
							this.KKSum = res.data.data.KK.SUM || 0;
						}
						if (res.data.data.CZ) {
							this.czCount = res.data.data.CZ.COUNT || 0;
							this.czSum = res.data.data.CZ.SUM || 0;
						}
						if (res.data.data.HC) {
							this.hcCount = res.data.data.HC.COUNT || 0;
							this.hcSum = res.data.data.HC.SUM || 0;
						}
						if (res.data.data.TK) {
							this.tKCount = res.data.data.TK.COUNT || 0;
							this.tkSum = res.data.data.TK.SUM || 0;
						}
						this.recordCount = res.data.count;
						if (this.RechargetypeValue == '') {
							this.RechargetypeValue = '全部'
						}

					} else {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});
					}
				}).catch(() => {
				}).finally(() => {
					this.tableLoading = false
				})
			},
			//获取当前时间
			getNowDay() {
				var date = new Date().getTime();
				var Ming = new Date().getTime() + 24 * 60 * 60 * 1000;
				var data = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(date))
				data = `${data} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [enddata, data];
				this.dateNowDayActive = true
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			datePickerChange(e) {
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},
			dateFtt(fmt, date) { //author: meizz
				var o = {
					"M+": date.getMonth() + 1, //月份
					"d+": date.getDate(), //日
					"h+": date.getHours(), //小时
					"m+": date.getMinutes(), //分
					"s+": date.getSeconds(), //秒
					"q+": Math.floor((date.getMonth() + 3) / 3), //季度
					"S": date.getMilliseconds() //毫秒
				};
				if (/(y+)/.test(fmt))
					fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
				for (var k in o)
					if (new RegExp("(" + k + ")").test(fmt))
						fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
							.length)));
				return fmt;
			},
			//获取昨天时间
			getYesterday() {
				var hms = new Date().getTime() - 24 * 60 * 60 * 1000;
				var Ming = new Date().getTime();
				var nowDay = this.dateFtt('yyyy-MM-dd', new Date(hms))
				var enddata = this.dateFtt('yyyy-MM-dd', new Date(Ming))
				nowDay = `${nowDay} ${this.exchangeTiem||'00:00:00'}`
				enddata = `${enddata} ${this.exchangeTiem||'00:00:00'}`
				this.date = [nowDay, enddata];
				this.dateNowDayActive = false
				this.dateYesterdayActive = true
				this.dateNowMonthActive = false
				this.dateLastMonthActive = false
			},

			handleCheckAllChange(val) {
				this.checkedCities = val ? this.cities : [];
				this.isIndeterminate = false;
				this.tableHeadList = val ? this.tableHeadListInit : []
			},
			handleCheckedCitiesChange(value) {
				//console.log(value)
				let checkedCount = value.length;
				this.checkAll = checkedCount === this.cities.length;
				this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
				var changearr = this.checkedCities;
				var initarr = this.tableHeadListInit;
				this.tableHeadList = this.$baseAPI.columnSetup(changearr, initarr);
			},
			handleSizeChange(val) {
				// 每页显示的条数
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.pageSize = val;
				this.currentPage = 1;
				this.initTableList();
			},
			handleCurrentChange(val) {
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.currentPage = val;
				this.initTableList();
			},
			//导出excle
			daochuExport() {
				var userORMTB400ID

				// console.log(this.userobj)
				if (this.userobj.pertb005.pertb005cb00 == "CUS-2") {
					userORMTB400ID = this.userobj.ormtb410.ORMTB400ID //一级企业id

				}
				if (this.userobj.pertb005.pertb005cb00 == "CUS-1") {
					userORMTB400ID = this.userobj.ormtb400.ORMTB400ID //一级企业id

				}
				// console.log(userORMTB400ID)
				var ORMTB410ID = this.customer;
				var ORMTB400ID = userORMTB400ID;
				var ORMTB420CA00 = this.numberValue;
				var ORMTB420CA01 = this.operateValue;

				var startTime = this.date[0]; //开始时间
				var endTime = this.date[1]; //结束时间
				var url = this.axios.defaults.baseURL + "/exc/toExcel/ormtb420toExcle?startTime=" + startTime +
					"&endTime=" + endTime + "&ORMTB410ID=" + ORMTB410ID + "&ORMTB400ID=" + ORMTB400ID + "&ORMTB420CA01=" +
					ORMTB420CA01 + "&ORMTB420CA00=" + ORMTB420CA00

				window.location.href = url;
				this.loadingBut = true
				var timer = null //倒计时
				this.confirmTxt = 30 - 1
				timer = setInterval(() => {
					if (this.confirmTxt === 0) {
						this.confirmTxt = ""
						this.loadingBut = false
						clearInterval(timer);
					} else {
						this.confirmTxt--
					}
				}, 1000);


			},


			uploadFile() {
				var url = "exc/toExcel/download"
				var startTime = this.date[0]; //开始时间
				console.log(startTime)
				console.log(startTime.slice(0, 10))
				let dztime = startTime.slice(0, 10)
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				var postData = {
					acDate: dztime
				}

				this.axios.post(url)
					.then(res => {
						console.log(res)
						//读取文件
						// 1.创建 FileReader 对象
						const fileReader = new FileReader()
						// 2.开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个字符串以表示所读取的文件内容。
						fileReader.readAsText(res.data) // 3.以字符串的形式读取出来
						fileReader.onload = () => {
							// 4.该事件在读取操作完成时触发。注意：此时this指向fileReader
							let result = JSON.parse(this.result) //获取的结果根据后端返回的数据类型选用json.parse
							if (result.code !== 0) {
								//如果读取失败进行响应的操作或提示
								return this.$message.error('文件读取失败')
							}
						}
						//导出文件
						// 通过a标签打开新页面下载文件
						const a = document.createElement('a')
						// 构造一个blob对象来处理数据
						const blob = new Blob[res.data]
						if (res.headers['content-disposition']) {
							// 拿到用户上传的文件名
							let fileName = res.headers['content-dispositon'].splice('filename=')[1]
							fileName = decodeURI(encodeURI(fileName))
							// URL.createObjectURL()会产生一个url字符串，可以像使用普通 URL 那样使用它，比如用在 img.src 上
							a.href = URL.createObjectURL(blob)
							// a标签里有download属性可以自定义文件名
							a.setAttribute(
								'download',
								fileName
							)
							document.body.appendChild(a)
							a.click();
							document.body.removeChild(a)
						}
					})
			},


			daochuReconciliationExport() {
				var userORMTB400ID
				// console.log(this.userobj)
				if (this.userobj.pertb005.pertb005cb00 == "CUS-2") {
					userORMTB400ID = this.userobj.ormtb410.ORMTB400ID //一级企业id

				}
				if (this.userobj.pertb005.pertb005cb00 == "CUS-1") {
					userORMTB400ID = this.userobj.ormtb400.ORMTB400ID //一级企业id

				}
				// console.log(userORMTB400ID)
				var ORMTB410ID = this.customer;
				var ORMTB400ID = userORMTB400ID;
				var ORMTB420CA00 = this.numberValue;
				var ORMTB420CA01 = this.operateValue;

				var startTime = this.date[0]; //开始时间
				console.log(startTime)
				console.log(startTime.slice(0, 10))
				let dztime = startTime.slice(0, 10)
				var endTime = this.date[1]; //结束时间
				var url = this.axios.defaults.baseURL + "/exc/toExcel/download?acDate=" + dztime
				window.location.href = url;
				this.loadingBut = true
				var timer = null //倒计时
				this.confirmTxtdzd = 30 - 1
				timer = setInterval(() => {
					if (this.confirmTxtdzd === 0) {
						this.confirmTxtdzd = ""
						this.loadingBut = false
						clearInterval(timer);
					} else {
						this.confirmTxtdzd--
					}
				}, 1000);


			},

			CZTypeQuery() {
				this.RechargetypeOptions = []
				console.log(this.userobj)

				var url = "/orm/ormtb411/selectCzTypeAll/" + this.userobj.ormtb400.ORMTB400CA03
				var loading = this.$loading({
					lock: true,
					text: '请求中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.5)'
				});
				this.axios.get(url).then(res => {
					// console.log(res)
					if (res.data.code == 200) {
						this.RechargetypeOptions = res.data.data
						// console.log(this.RechargetypeOptions)
					} else {
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					setTimeout(() => {
						loading.close()
					}, 300)
				}).catch(() => {
					loading.close()
				})
			},
			queryClick() {
				if (this.tableLoading) return
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.initTableList();
			},
			quanPing() {
				var mark = 1;
				var objInfo = {
					startTime: this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(this.date[0])),
					endTime: this.$baseAPI.dateFtt("yyyy-MM-dd", new Date(this.date[1])),
					customer: this.customer,
					customerOptions: this.customerOptions,
					carNum: this.carNum,
					operateValue: this.operateValue,
					RechargetypeValue: this.RechargetypeValue,
					numberValue: this.numberValue
				}
				sessionStorage.setItem(
					"qpSolelist",
					JSON.stringify(this.$store.state.solelist)
				);
				sessionStorage.setItem("CD01", JSON.stringify(this.$store.state.uobj.pertb005.pertb005cd01));
				sessionStorage.setItem("qpUobj", JSON.stringify(this.$store.state.uobj));
				sessionStorage.setItem("objInfo", JSON.stringify(objInfo));
				let Logistics = this.$router.resolve({
					path: '/BillDetails',
					query: {
						mark: mark
					}
				})
				this.$baseAPI.requestFullScreen(Logistics);
			},
			//获取当月
			getNowMonth() {
				var date = new Date();
				var hms = date.setDate(1);
				var firstDay = this.dateFtt('yyyy-MM-dd', new Date(hms));
				firstDay = `${firstDay} ${this.exchangeTiem||'00:00:00'}`
				var nextdate = new Date().getTime() + 24 * 60 * 60 * 1000;
				var nextDay = this.dateFtt('yyyy-MM-dd', new Date(nextdate));
				nextDay = `${nextDay} ${this.exchangeTiem||'00:00:00'}`
				this.date = [firstDay, nextDay];
				this.startTime = this.date[0];
				this.endTime = this.date[1];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = true
				this.dateLastMonthActive = false
			},
			//获取上个月
			getLastMonth() {
				var nowdays = new Date();
				var year = nowdays.getFullYear();
				var month = nowdays.getMonth();
				var lastyear = year
				var lastmonth = month
				if (month == 0) {
					month = 12;
					year = year - 1;
				}
				if (month == 12) {
					lastmonth = 1
				} else {
					lastmonth = lastmonth + (1 * 1)
				}
				if (month < 10) {
					month = "0" + month;
				}
				if (lastmonth < 10) {
					lastmonth = "0" + lastmonth;
				}
				var firstDayOfPreMonth = year + "-" + month + "-" + "01";
				var firstDayOfPreMonth = `${year}-${month}-01 ${this.exchangeTiem||'00:00:00'}`;
				// var lastDay = new Date(lastyear, lastmonth, 0);
				let lastDayOfPreMonth = `${lastyear}-${lastmonth}-01 ${this.exchangeTiem||'00:00:00'}`;
				this.date = [firstDayOfPreMonth, lastDayOfPreMonth];
				this.dateNowDayActive = false
				this.dateYesterdayActive = false
				this.dateNowMonthActive = false
				this.dateLastMonthActive = true
			},

		}
	}
</script>

<style scoped>
	.zhezhao {
		position: fixed;
		top: 0;
		background: rgba(0, 0, 0, 0);
		text-align: center;
		height: 100%;
		width: 100%;
		z-index: 2003;
		left: 0;
		overflow: hidden;
	}

	.fontBlue {
		color: rgba(25, 159, 255, 1) !important;
	}

	.public_singleMenu .pulic_carNumber {
		margin-top: 6px;
		height: 40px;
		line-height: 40px;
		box-sizing: border-box;
		font-size: 14px;
		display: inline-block;
	}

	/* 	.billOperationRecord .public_oparetionBlock_Menu{
		height: 45px;
		align-items: center;
	} */
	.billDetails th,
	.billDetails td {
		text-align: center;
	}

	.tableHeadSet {
		position: absolute;
		margin-top: 3%;
		right: 26.5%;
		background: #ffffff;
		width: 10.417vw;
		height: 15.625vw;
		z-index: 99999999;
		box-shadow: 0px -0.521vw 0px 0px #f8f8f8, 0.521vw 0px 0px 0px #f8f8f8;
	}

	.salesWater_lieSetCheck label {
		width: 100%;
	}

	.salesWater_checkbox {
		display: block;
		margin-top: 4px;
	}

	.salesWater_arrow {
		font-size: 20px;
		vertical-align: middle;
	}

	.payType {
		font-size: 20px;
		/* font-size: 24px; */
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(102, 102, 102, 1);
		line-height: 26px;
	}

	.totolTitle {
		font-size: 16px !important;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #666666;
		line-height: 28px;
		margin-right: 5px;
		/* margin-right: 14px; */
		vertical-align: middle;
	}

	.singular {
		font-size: 32px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: rgba(51, 51, 51, 1);
		line-height: 30px;
		vertical-align: middle;
	}

	.billDetails-statistics {
		margin-right: 6px !important;
	}

	.billDetails-ul {
		margin-left: 10px !important;
	}

	.Amount {
		font-size: 32px;
		font-family: Microsoft YaHei;
		/* font-weight:bold; */
		line-height: 30px;
		vertical-align: middle;
	}


		.billDetails {
			--bill-primary: #178bff;
			--bill-primary-deep: #0f72d8;
			--bill-green: #08b985;
			--bill-orange: #ff9e4f;
			--bill-red: #ff5a45;
			--bill-yellow: #fdb725;
			--bill-text: #263f58;
			--bill-strong: #12375c;
			--bill-muted: #7890a6;
			--bill-border: #dce9f5;
			--bill-border-soft: #edf4fb;
			--bill-card: rgba(255, 255, 255, 0.96);
			--bill-shadow: 0 18px 42px rgba(31, 115, 184, 0.11);
			--bill-shadow-soft: 0 10px 26px rgba(31, 115, 184, 0.08);
			position: relative;
			display: grid;
			gap: 12px;
			min-height: 100%;
			padding: 12px;
			overflow: hidden;
			background:
				radial-gradient(circle at 7% 0, rgba(25, 159, 255, 0.12), transparent 280px),
				radial-gradient(circle at 100% 28%, rgba(8, 185, 133, 0.1), transparent 320px),
				linear-gradient(180deg, #f6fbff 0%, #edf4fa 100%);
			color: var(--bill-text);
			font-family: Microsoft YaHei, PingFang SC, sans-serif;
		}

		.billDetails::before {
			content: '';
			position: absolute;
			top: 0;
			right: 0;
			bottom: 0;
			left: 0;
			z-index: 0;
			pointer-events: none;
			background-image:
				linear-gradient(rgba(25, 159, 255, 0.04) 1px, transparent 1px),
				linear-gradient(90deg, rgba(25, 159, 255, 0.04) 1px, transparent 1px);
			background-size: 34px 34px;
		}

		.billDetails > * {
			position: relative;
			z-index: 1;
		}

		.billDetails-filter-card {
			position: relative;
			padding: 0 !important;
			margin-bottom: 0;
			border: 1px solid rgba(199, 219, 237, 0.98) !important;
			border-radius: 20px !important;
			background: rgba(255, 255, 255, 0.96) !important;
			box-shadow: 0 18px 42px rgba(31, 115, 184, 0.11) !important;
			overflow: hidden;
		}

		.billDetails-hero-main {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 18px;
			padding: 18px 20px;
			background:
				radial-gradient(circle at 92% 0, rgba(8, 185, 133, 0.13), transparent 220px),
				linear-gradient(135deg, #f7fbff 0%, #ffffff 100%);
			border-bottom: 1px solid rgba(230, 239, 248, 0.9);
			overflow: hidden;
		}

		.billDetails-hero-main::before {
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			bottom: 0;
			width: 5px;
			background: linear-gradient(180deg, #199fff 0%, #08b985 100%);
		}

		.billDetails-hero-main > div {
			position: relative;
			z-index: 1;
		}

		.billDetails-eyebrow {
			color: #199fff;
			font-size: 12px;
			font-weight: 900;
			letter-spacing: 0.12em;
		}

		.billDetails-title {
			margin-top: 4px;
			color: #12375c;
			font-size: 24px;
			font-weight: 900;
			line-height: 32px;
		}

		.billDetails-desc {
			margin-top: 4px;
			color: #7890a6;
			font-size: 13px;
			line-height: 20px;
		}

		.billDetails-hero-meta {
			display: grid;
			place-items: center;
			min-width: 112px;
			min-height: 82px;
			border: 1px solid rgba(25, 159, 255, 0.18);
			border-radius: 16px;
			background: rgba(239, 248, 255, 0.78);
			box-shadow: 0 10px 24px rgba(25, 159, 255, 0.08);
		}

		.billDetails-hero-meta span,
		.billDetails-hero-meta em {
			color: #7890a6;
			font-size: 12px;
			font-style: normal;
			font-weight: 800;
		}

		.billDetails-hero-meta strong {
			color: #199fff;
			font-size: 26px;
			font-weight: 900;
			line-height: 30px;
		}

		.billDetails-section-head,
		.billDetails-table-head {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 12px;
			margin-bottom: 12px;
		}

		.billDetails-section-head + .public_statisticsInfo,
		.billDetails-stat-head + .public_statisticsInfo {
			margin-top: 0;
		}

		.billDetails-filter-card .billDetails-section-head {
			margin: 0;
			padding: 16px 18px 12px;
			background: linear-gradient(180deg, rgba(248, 251, 255, 0.82) 0%, rgba(255, 255, 255, 0.98) 100%);
		}

		.billDetails-section-head span,
		.billDetails-table-head span {
			display: block;
			color: #163b5e;
			font-size: 15px;
			font-weight: 900;
			line-height: 22px;
		}

		.billDetails-section-head p,
		.billDetails-table-head p {
			margin: 3px 0 0;
			color: #7890a6;
			font-size: 12px;
			line-height: 18px;
		}

		.billDetails-section-head strong,
		.billDetails-table-head strong {
			padding: 5px 10px;
			border-radius: 999px;
			background: #eef7ff;
			color: #3781bd;
			font-size: 12px;
			font-weight: 900;
			white-space: nowrap;
		}

		.billDetails-filter-grid {
			padding: 14px 18px 0;
			background: rgba(255, 255, 255, 0.98);
		}

		.billDetails-filter-grid + .public_operatArea {
			margin-top: 12px;
			border-top: 1px dashed rgba(220, 230, 242, 0.96);
			padding-top: 14px;
			background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
		}

		.billDetails-filter-tags {
			display: flex;
			flex-wrap: wrap;
			gap: 8px;
			padding: 0 18px 16px;
			margin-top: -4px;
			background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
		}

		.billDetails-filter-tag {
			display: inline-flex;
			align-items: center;
			gap: 6px;
			max-width: 360px;
			padding: 6px 10px;
			border: 1px solid rgba(25, 159, 255, 0.14);
			border-radius: 999px;
			background: #eef7ff;
			color: #315f86;
			font-size: 12px;
			font-weight: 700;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.billDetails-filter-tag em {
			font-style: normal;
			color: var(--bill-primary);
			font-weight: 900;
		}

		.billDetails > .pulbic_oparetionBlock:first-child {
			position: relative;
			padding: 16px 18px;
			margin-bottom: 16px;
			border: 1px solid rgba(220, 230, 242, 0.96);
			border-radius: var(--fszs-radius-lg);
			background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
			box-shadow: var(--fszs-shadow-sm);
		}

		.billDetails .public_criteriaRange {
			display: grid !important;
			grid-template-columns: repeat(3, minmax(0, 1fr));
			gap: 12px;
			align-items: start;
		}

		.billDetails .public_singleMenu {
			display: grid !important;
			grid-template-columns: 78px minmax(0, 1fr);
			align-items: center;
			gap: 8px;
			margin: 0;
			padding: 10px 12px;
			border: 1px solid rgba(230, 239, 248, 0.95);
			border-radius: 14px;
			background: rgba(248, 251, 255, 0.92);
			transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease, background 0.2s ease;
		}

		.billDetails .public_singleMenu:hover,
		.billDetails .public_singleMenu:focus-within {
			border-color: rgba(25, 159, 255, 0.32);
			background: #ffffff;
			box-shadow: 0 10px 22px rgba(25, 159, 255, 0.08);
			transform: translateY(-1px);
		}

		.billDetails .public_lbSty {
			width: auto;
			color: var(--fszs-text-muted);
			font-weight: 600;
			white-space: nowrap;
		}

		.billDetails .public_optionSty,
		.billDetails .public_singleMenu .el-select {
			width: 100%;
		}

		.billDetails .billDetails-filter-grid .public_singleMenu:nth-child(1),
		.billDetails .billDetails-filter-grid .public_singleMenu:nth-child(2),
		.billDetails .billDetails-filter-grid .public_singleMenu:nth-child(3) {
			min-height: 62px;
		}

		.billDetails .public_lbSty {
			width: auto;
			color: var(--fszs-text-muted);
			font-weight: 600;
		}

		.billDetails .public_optionSty,
		.billDetails .public_singleMenu .el-select {
			width: 100% !important;
		}

		.billDetails /deep/.el-input__inner,
		.billDetails .pulic_carNumber {
			height: 38px;
			line-height: 38px;
			border-color: var(--fszs-border);
			border-radius: 9px;
			background: #f8fbff;
			color: var(--fszs-text);
		}

		.billDetails /deep/.el-input__inner:focus,
		.billDetails .pulic_carNumber:focus {
			border-color: var(--fszs-primary);
			background: #ffffff;
			box-shadow: var(--fszs-focus);
		}

		.billDetails .public_operatArea {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			gap: 10px;
			margin-top: 12px;
			padding: 0 18px 18px;
		}

		.billDetails .public_operatBtn,
		.billDetails-filter-actions {
			position: static !important;
			display: inline-flex;
			align-items: center;
			gap: 10px;
			margin-left: auto;
			padding: 7px;
			border: 1px solid rgba(220, 230, 242, 0.95);
			border-radius: 18px;
			background:
				linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, rgba(247, 251, 255, 0.94) 100%);
			box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.95), 0 12px 26px rgba(31, 115, 184, 0.08);
		}

		.billDetails .public_saleWater_chaxun,
		.billDetails .public_saleWater_daochu {
			position: relative;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			gap: 8px;
			min-width: 116px;
			height: 42px;
			padding: 0 18px 0 14px;
			border-radius: 14px;
			font-size: 14px;
			font-weight: 900;
			line-height: 42px;
			letter-spacing: 0.03em;
			overflow: hidden;
			transition: box-shadow 0.22s ease, transform 0.22s ease, opacity 0.22s ease, background 0.22s ease, border-color 0.22s ease, color 0.22s ease;
		}

		.billDetails .public_saleWater_chaxun::before,
		.billDetails .public_saleWater_daochu::before {
			content: '';
			position: absolute;
			top: 0;
			left: -80%;
			width: 58%;
			height: 100%;
			background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.42) 50%, transparent 100%);
			transform: skewX(-18deg);
			transition: left 0.45s ease;
		}

		.billDetails .public_saleWater_chaxun:hover::before,
		.billDetails .public_saleWater_daochu:hover::before {
			left: 128%;
		}

		.billDetails .billDetails-action-icon {
			position: relative;
			z-index: 1;
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 26px;
			height: 26px;
			margin-right: 4px;
			border-radius: 10px;
			background: rgba(255, 255, 255, 0.18);
			box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.22);
		}

		.billDetails .billDetails-action-icon.is-export {
			background: rgba(255, 255, 255, 0.2);
			color: #ffffff;
		}

		.billDetails .billDetails-action-icon i {
			font-size: 14px !important;
			margin-right: 0;
		}

		.billDetails .billDetails-action-text,
		.billDetails .billDetails-action-count {
			position: relative;
			z-index: 1;
		}

		.billDetails .public_saleWater_chaxun:hover,
		.billDetails .public_saleWater_daochu:hover {
			transform: translateY(-2px);
		}

		.billDetails .public_saleWater_chaxun {
			border: 0;
			background:
				linear-gradient(135deg, #178bff 0%, #08c98a 100%);
			color: #ffffff;
			box-shadow: 0 12px 24px rgba(23, 139, 255, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.24);
		}

		.billDetails .public_saleWater_chaxun:hover {
			box-shadow: 0 18px 32px rgba(23, 139, 255, 0.30), inset 0 1px 0 rgba(255, 255, 255, 0.28);
		}

		.billDetails .public_saleWater_chaxun.is-loading,
		.billDetails .public_saleWater_chaxun:disabled {
			cursor: not-allowed;
			opacity: 0.78;
			transform: none;
			box-shadow: 0 8px 18px rgba(23, 139, 255, 0.16);
		}

		.billDetails .public_saleWater_chaxun.is-loading::before,
		.billDetails .public_saleWater_chaxun:disabled::before {
			display: none;
		}

		.billDetails .public_saleWater_daochu {
			border: 0;
			background:
				linear-gradient(135deg, #ff9e4f 0%, #ff6b35 100%);
			color: #ffffff;
			box-shadow: 0 10px 22px rgba(255, 107, 53, 0.22), inset 0 1px 0 rgba(255, 255, 255, 0.24);
		}

		.billDetails .public_saleWater_daochu:hover {
			background: linear-gradient(135deg, #ffab63 0%, #ff5f24 100%);
			color: #ffffff;
			box-shadow: 0 16px 30px rgba(255, 107, 53, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.28);
		}

		.billDetails .public_saleWater_daochu.is-loading,
		.billDetails .public_saleWater_daochu.is-disabled {
			opacity: 0.78;
			transform: none;
		}

		.billDetails-action-count {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			min-width: 20px;
			height: 20px;
			padding: 0 6px;
			border-radius: 999px;
			background: rgba(255, 90, 69, 0.12);
			color: #ff5a45;
			font-size: 12px;
			font-weight: 900;
			line-height: 20px;
			box-shadow: inset 0 0 0 1px rgba(255, 90, 69, 0.08);
		}

		.billDetails .pulic_operatArea_now,
		.billDetails .public_operatArea_yesterday {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			height: 36px;
			padding: 0 16px;
			border: 1px solid var(--fszs-border);
			border-radius: 999px;
			background: #ffffff;
			color: var(--fszs-text-muted);
			box-shadow: 0 6px 14px rgba(31, 115, 184, 0.04);
			transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease, background 0.2s ease, color 0.2s ease;
		}

		.billDetails .pulic_operatArea_now:hover,
		.billDetails .public_operatArea_yesterday:hover {
			border-color: rgba(25, 159, 255, 0.28);
			color: #199fff;
			box-shadow: 0 10px 20px rgba(25, 159, 255, 0.1);
			transform: translateY(-1px);
		}

		.billDetails .public_dateActive {
			border-color: rgba(23, 139, 255, 0.25);
			background: linear-gradient(135deg, rgba(23, 139, 255, 0.16) 0%, rgba(8, 185, 133, 0.1) 100%);
			color: var(--fszs-primary);
			font-weight: 700;
		}

		.billDetails .public_operatArea_timePicker /deep/.el-date-editor {
			width: 360px;
		}

		.billDetails-panel {
			position: relative;
			padding: 0;
			border: 1px solid rgba(199, 219, 237, 0.98);
			border-radius: 20px;
			background: rgba(255, 255, 255, 0.96);
			box-shadow: 0 18px 42px rgba(31, 115, 184, 0.11);
			overflow: hidden;
		}

		.billDetails-stat-panel {
			padding: 18px 18px 16px;
		}

		.billDetails-table-panel {
			padding: 18px;
		}

		.billDetails-table-panel .billDetails-table {
				position: relative;
			padding: 0;
			border: 0;
			border-radius: 0;
			background: transparent;
			box-shadow: none;
		}

		.billDetails-stat-head {
			position: relative;
			z-index: 2;
			min-height: 52px;
			padding: 0 0 14px;
			margin: 0 0 16px;
			border-bottom: 1px solid rgba(230, 239, 248, 0.96);
			box-sizing: border-box;
		}

		.billDetails-stat-head::before,
		.billDetails-table-head::before {
			content: none;
		}

		.billDetails-stat-head > div,
		.billDetails-table-head > div {
			position: relative;
			padding-left: 16px;
		}

		.billDetails-stat-head > div::before,
		.billDetails-table-head > div::before {
			content: '';
			position: absolute;
			left: 0;
			top: 7px;
			width: 7px;
			height: 7px;
			border-radius: 50%;
			background: #199fff;
			box-shadow: 0 0 0 4px rgba(25, 159, 255, 0.12);
		}

		.billDetails .public_statisticsInfo {
			position: relative;
			z-index: 1;
			display: grid;
			grid-template-columns: repeat(4, minmax(0, 1fr));
			gap: 14px;
			padding: 0;
			margin: 0;
			border: none;
			background: transparent;
			box-shadow: none;
		}

		.billDetails .public_statistics {
			position: relative;
			min-height: 132px;
			padding: 18px 20px;
			margin-right: 0 !important;
			border: 1px solid rgba(220, 230, 242, 0.96);
			border-radius: var(--fszs-radius-lg);
			background:
				radial-gradient(circle at 100% 0, rgba(25, 159, 255, 0.08), transparent 160px),
				linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
			box-shadow: var(--fszs-shadow-sm);
			overflow: hidden;
			transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
		}

		.billDetails .public_statistics::before {
			content: '';
			position: absolute;
			left: 0;
			top: 0;
			bottom: 0;
			width: 4px;
			background: linear-gradient(180deg, #199fff 0%, #08b985 100%);
		}

		.billDetails .public_statistics:nth-child(1)::before {
			background: linear-gradient(180deg, #ff9e4f 0%, #199fff 100%);
		}

		.billDetails .public_statistics:nth-child(2)::before {
			background: linear-gradient(180deg, #ff5a45 0%, #30a8ff 100%);
		}

		.billDetails .public_statistics:nth-child(3)::before {
			background: linear-gradient(180deg, #08d691 0%, #199fff 100%);
		}

		.billDetails .public_statistics:nth-child(4)::before {
			background: linear-gradient(180deg, #fdb725 0%, #08d691 100%);
		}

		.billDetails .public_statistics:hover {
			border-color: rgba(25, 159, 255, 0.26);
			box-shadow: 0 16px 34px rgba(31, 115, 184, 0.11);
			transform: translateY(-2px);
		}

		.billDetails .public_statisticsContent {
			display: flex;
			align-items: center;
			gap: 10px;
		}

		.billDetails .public_statisticsContent i {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			width: 34px;
			height: 34px;
			border-radius: 12px;
			background: rgba(239, 248, 255, 0.92);
			box-shadow: inset 0 0 0 1px rgba(220, 230, 242, 0.92);
		}

		.billDetails .billDetails-ul {
			margin: 14px 0 0 !important;
			padding: 0;
			list-style: none;
		}

		.billDetails .pulic_statistics_titlt {
			display: flex;
			align-items: baseline;
			justify-content: space-between;
			gap: 12px;
			line-height: 1.6;
		}

		.billDetails .payType {
			color: var(--fszs-text-strong);
			font-size: 18px;
		}

		.billDetails .totolTitle {
			color: var(--fszs-text-muted);
			font-size: 14px !important;
		}

		.billDetails .Amount,
		.billDetails .singular {
			color: var(--fszs-text-strong);
			font-size: 28px;
			font-weight: 700;
			line-height: 1.2;
		}

		.billDetails-table {
			padding: 16px 16px 0;
			border: 1px solid rgba(220, 230, 242, 0.96);
			border-radius: var(--fszs-radius-lg);
			background: rgba(255, 255, 255, 0.96);
			box-shadow: 0 14px 36px rgba(31, 115, 184, 0.08);
			overflow: hidden;
		}

		.billDetails-table-head {
			padding: 2px 2px 12px;
			margin-bottom: 14px;
			border-bottom: 1px solid rgba(237, 244, 251, 0.9);
		}

		.billDetails-table /deep/.el-table {
			border-radius: 12px;
			overflow: hidden;
		}

		.billDetails-table /deep/.el-table__row {
			transition: background 0.2s ease;
		}

		.billDetails-table /deep/.el-table__row:hover > td {
			background: #f4fbff !important;
		}

		.billDetails-table /deep/.el-table__body-wrapper {
			max-height: calc(100vh - 440px) !important;
		}

		.billDetails-table /deep/.el-table__header-wrapper th {
			background: linear-gradient(180deg, #f4f9ff 0%, #edf6ff 100%) !important;
			color: var(--fszs-text-strong) !important;
		}

		.billDetails-table /deep/.el-table__body td {
			color: #334e68;
			font-size: 13px;
		}

		.billDetails-table /deep/.el-table__body td:nth-child(4),
		.billDetails-table /deep/.el-table__body td:nth-child(5),
		.billDetails-table /deep/.el-table__body td:nth-child(6) {
			color: #12375c;
			font-weight: 800;
		}

		.billDetails-table /deep/.el-table__body td:nth-child(5) {
			color: #199fff;
		}

		.billDetails-table /deep/.el-table__empty-block {
			min-height: 180px;
		}

		.billDetails .pulbic_pagesize {
			display: flex;
			justify-content: flex-end;
			padding: 12px 0 0;
			border-top: 1px solid var(--fszs-border-soft);
			background: #ffffff;
		}

		@media screen and (max-width: 1280px) {
			.billDetails {
				padding: 12px;
			}

			.billDetails .public_criteriaRange {
				grid-template-columns: 1fr;
			}

			.billDetails-hero-main,
			.billDetails-section-head,
			.billDetails-table-head {
				align-items: flex-start;
				flex-direction: column;
			}

			.billDetails .public_operatArea {
				padding: 0 12px 14px;
			}

			.billDetails-filter-grid {
				padding: 0 12px;
			}

			.billDetails .public_operatArea_timePicker /deep/.el-date-editor {
				width: 100%;
			}

			.billDetails .public_operatBtn {
				width: 100%;
				margin-left: 0;
			}

			.billDetails .public_saleWater_chaxun,
			.billDetails .public_saleWater_daochu {
				flex: 1;
			}
		}
		.billDetails-filter-card,
		.billDetails-panel {
			border-radius: 22px !important;
			background: var(--bill-card) !important;
			box-shadow: var(--bill-shadow) !important;
		}

		.billDetails-panel::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			height: 3px;
			background: linear-gradient(90deg, var(--bill-primary) 0%, var(--bill-green) 100%);
		}

		.billDetails-hero-main {
			min-height: 120px;
			gap: 20px;
			padding: 22px 24px;
		}

		.billDetails-hero-main::before {
			background: linear-gradient(180deg, var(--bill-primary) 0%, var(--bill-green) 100%);
		}

		.billDetails-hero-main::after {
			content: '';
			position: absolute;
			right: -56px;
			top: -64px;
			width: 176px;
			height: 176px;
			border: 30px solid rgba(25, 159, 255, 0.06);
			border-radius: 50%;
		}

		.billDetails-eyebrow {
			color: var(--bill-primary);
			letter-spacing: 0.14em;
		}

		.billDetails-title {
			margin-top: 6px;
			color: var(--bill-strong);
			font-size: 26px;
			line-height: 34px;
		}

		.billDetails-desc {
			margin-top: 6px;
			color: var(--bill-muted);
			line-height: 21px;
		}

		.billDetails-hero-meta {
			min-width: 118px;
			min-height: 88px;
			border-radius: 18px;
			background: rgba(239, 248, 255, 0.82);
		}

		.billDetails-hero-meta strong {
			color: var(--bill-primary);
			font-size: 30px;
			line-height: 34px;
		}

		.billDetails-section-head,
		.billDetails-table-head {
			gap: 16px;
		}

		.billDetails-section-head > div,
		.billDetails-table-head > div {
			min-width: 0;
		}

		.billDetails-section-head span,
		.billDetails-table-head span {
			color: var(--bill-strong);
		}

		.billDetails-section-head p,
		.billDetails-table-head p {
			color: var(--bill-muted);
			white-space: normal;
		}

		.billDetails-section-head strong,
		.billDetails-table-head strong {
			flex-shrink: 0;
			padding: 6px 12px;
			border: 1px solid rgba(25, 159, 255, 0.12);
			line-height: 16px;
		}

		.billDetails-filter-card .billDetails-section-head {
			padding: 13px 18px 10px;
		}

		.billDetails-filter-card .billDetails-section-head > div::before {
			background: var(--bill-green);
			box-shadow: 0 0 0 4px rgba(8, 185, 133, 0.12);
		}

		.billDetails-filter-grid {
			padding: 10px 18px 0;
		}

		.billDetails .public_criteriaRange {
			grid-template-columns: repeat(3, minmax(240px, 1fr)) !important;
			gap: 10px;
		}

		.billDetails .public_singleMenu {
			grid-template-columns: 82px minmax(0, 1fr);
			gap: 8px;
			min-height: 56px;
			padding: 8px 12px;
			border-radius: 16px;
			background: linear-gradient(180deg, rgba(255, 255, 255, 0.94) 0%, rgba(248, 251, 255, 0.96) 100%);
			box-shadow: 0 6px 16px rgba(31, 115, 184, 0.04);
		}

		.billDetails .public_singleMenu:hover,
		.billDetails .public_singleMenu:focus-within {
			box-shadow: 0 12px 24px rgba(25, 159, 255, 0.09);
		}

		.billDetails .public_lbSty {
			color: var(--bill-muted);
			font-size: 13px;
			font-weight: 800;
		}

		.billDetails /deep/.el-input__inner,
		.billDetails .pulic_carNumber {
			border-color: var(--bill-border);
			border-radius: 10px;
			color: var(--bill-text);
			transition: border-color 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
		}

		.billDetails /deep/.el-input__inner:focus,
		.billDetails .pulic_carNumber:focus {
			border-color: var(--bill-primary);
			box-shadow: 0 0 0 3px rgba(23, 139, 255, 0.12);
		}

		.billDetails .public_operatArea {
			gap: 8px 10px;
			padding: 12px 18px 14px;
			border-top: 1px dashed rgba(220, 230, 242, 0.96);
			background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
		}

		.billDetails .pulic_operatArea_now,
		.billDetails .public_operatArea_yesterday {
			border-color: var(--bill-border);
			color: var(--bill-muted);
			font-weight: 700;
		}

		.billDetails .pulic_operatArea_now:hover,
		.billDetails .public_operatArea_yesterday:hover {
			color: var(--bill-primary);
		}

		.billDetails .public_dateActive {
			color: var(--bill-primary);
			font-weight: 900;
		}

		.billDetails .public_operatArea_timePicker {
			flex: 1 1 360px;
			max-width: 520px;
			min-width: 320px;
		}

		.billDetails .public_operatArea_timePicker /deep/.el-date-editor {
			width: 100%;
		}

		.billDetails .public_operatBtn,
		.billDetails-filter-actions {
			display: inline-flex !important;
		}

		.billDetails-stat-panel {
			padding: 14px 18px;
		}

		.billDetails-stat-head {
			min-height: 48px;
			padding: 0 18px 12px 0;
			margin: 0 0 12px;
		}

		.billDetails .public_statisticsInfo {
			display: grid !important;
			width: 100%;
			grid-template-columns: repeat(4, minmax(0, 1fr));
			gap: 10px;
			height: auto !important;
			min-height: 0 !important;
			padding: 0 !important;
				box-sizing: border-box;
			margin: 0 !important;
			font-family: inherit;
			font-size: inherit;
		}

		.billDetails .public_statistics {
			display: flex !important;
			flex-direction: column;
			align-items: stretch;
			justify-content: space-between;
			min-height: 132px;
			height: auto !important;
			padding: 14px 16px 12px;
			margin: 0 !important;
			border-radius: 18px;
			box-shadow: var(--bill-shadow-soft);
		}

		.billDetails .public_statistics::after {
				content: '';
				position: absolute;
				right: -24px;
				top: 14px;
				z-index: 0;
				width: 112px;
				height: 112px;
				border: 16px solid rgba(25, 159, 255, 0.12);
				border-radius: 50%;
				background: transparent;
				box-sizing: border-box;
				pointer-events: none;
		}

		.billDetails .public_statistics:hover {
			box-shadow: 0 18px 36px rgba(31, 115, 184, 0.12);
		}

		.billDetails .public_statisticsContent {
				position: relative;
				z-index: 1;
			text-align: left;
		}

		.billDetails .public_statisticsContent i {
			width: 38px;
			height: 38px;
			border-radius: 14px;
			font-size: 20px !important;
		}

		.billDetails .payType {
			color: var(--bill-strong);
			font-size: 18px;
			font-weight: 900;
		}

		.billDetails .public_statistics ul,
		.billDetails .billDetails-ul {
				position: relative;
				z-index: 1;
			display: grid;
			gap: 8px;
			float: none;
			margin: 12px 0 0 !important;
		}

		.billDetails .pulic_statistics_titlt {
			align-items: center;
			min-height: 32px;
			font-family: inherit;
			line-height: 1.4;
		}

		.billDetails .pulic_statistics_titlt:first-child {
			align-items: flex-start;
			flex-direction: column;
			gap: 4px;
			padding: 10px 12px;
			border: 1px solid rgba(230, 239, 248, 0.86);
			border-radius: 14px;
			background: linear-gradient(180deg, rgba(255, 255, 255, 0.96) 0%, #f5fbff 100%);
		}

		.billDetails .pulic_statistics_titlt:last-child {
			padding: 0 2px;
		}

		.billDetails .totolTitle {
			margin-right: 0;
			color: var(--bill-muted);
			font-size: 13px !important;
			font-weight: 700;
			line-height: 18px;
		}

		.billDetails .Amount,
		.billDetails .singular {
			font-family: Microsoft YaHei, PingFang SC, sans-serif;
			font-weight: 900;
		}

		.billDetails .Amount {
			font-size: 30px;
			word-break: break-all;
		}

		.billDetails .singular {
			padding: 4px 10px;
			border-radius: 999px;
			background: #f5f9fd;
			color: var(--bill-strong);
			font-size: 18px;
		}


			.billDetails .public_statistics.is-recharge {
				--stat-color: #199fff;
				--stat-sub-color: #ff9e4f;
				--stat-bg: rgba(25, 159, 255, 0.08);
				--stat-arc: rgba(25, 159, 255, 0.16);
			}

			.billDetails .public_statistics.is-reversal {
				--stat-color: #ff5a45;
				--stat-sub-color: #30a8ff;
				--stat-bg: rgba(255, 90, 69, 0.08);
				--stat-arc: rgba(255, 90, 69, 0.16);
			}

			.billDetails .public_statistics.is-deduct {
				--stat-color: #08d691;
				--stat-sub-color: #199fff;
				--stat-bg: rgba(8, 214, 145, 0.08);
				--stat-arc: rgba(8, 214, 145, 0.16);
			}

			.billDetails .public_statistics.is-refund {
				--stat-color: #fdb725;
				--stat-sub-color: #08d691;
				--stat-bg: rgba(253, 183, 37, 0.1);
				--stat-arc: rgba(253, 183, 37, 0.18);
			}

			.billDetails .public_statistics.is-recharge::before,
			.billDetails .public_statistics.is-reversal::before,
			.billDetails .public_statistics.is-deduct::before,
			.billDetails .public_statistics.is-refund::before {
				background: linear-gradient(180deg, var(--stat-sub-color) 0%, var(--stat-color) 100%);
			}

			.billDetails .public_statistics.is-recharge::after,
			.billDetails .public_statistics.is-reversal::after,
			.billDetails .public_statistics.is-deduct::after,
			.billDetails .public_statistics.is-refund::after {
				border-color: var(--stat-arc);
				background: transparent;
				box-shadow: none;
			}

			.billDetails .public_statistics.is-recharge .public_statisticsContent i,
			.billDetails .public_statistics.is-reversal .public_statisticsContent i,
			.billDetails .public_statistics.is-deduct .public_statisticsContent i,
			.billDetails .public_statistics.is-refund .public_statisticsContent i {
				background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, var(--stat-bg) 100%);
				color: var(--stat-sub-color) !important;
				box-shadow: inset 0 0 0 1px var(--stat-bg), 0 10px 20px var(--stat-bg);
			}

			.billDetails .public_statistics.is-recharge .Amount,
			.billDetails .public_statistics.is-reversal .Amount,
			.billDetails .public_statistics.is-deduct .Amount,
			.billDetails .public_statistics.is-refund .Amount {
				color: var(--stat-color);
			}

			.billDetails .public_statistics.is-recharge .singular,
			.billDetails .public_statistics.is-reversal .singular,
			.billDetails .public_statistics.is-deduct .singular,
			.billDetails .public_statistics.is-refund .singular {
				background: var(--stat-bg);
				color: var(--stat-color);
			}

		.billDetails-table-panel {
			padding: 14px;
		}

		.billDetails-table-panel .billDetails-table {
			border: 1px solid rgba(220, 230, 242, 0.96);
			border-radius: 18px;
			background: rgba(255, 255, 255, 0.98);
			box-shadow: var(--bill-shadow-soft);
		}

		.billDetails-table-head {
			padding: 14px 18px;
			margin: 0;
			border-bottom: 1px solid rgba(230, 239, 248, 0.96);
			background: linear-gradient(180deg, #fbfdff 0%, #f6fbff 100%);
		}

		.billDetails-table /deep/.el-table {
			border-radius: 0;
		}

		.billDetails-table /deep/.el-table::before {
			height: 0;
		}

		.billDetails-table /deep/.el-table__header-wrapper th {
			height: 48px;
			border-bottom: 1px solid rgba(220, 230, 242, 0.96) !important;
			color: var(--bill-strong) !important;
			font-size: 13px;
			font-weight: 900 !important;
		}

		.billDetails-table /deep/.el-table__body td {
			height: 46px;
			border-bottom: 1px solid rgba(237, 244, 251, 0.9);
		}

		.billDetails-table /deep/.el-table__body-wrapper {
			max-height: calc(100vh - 460px) !important;
		}

		.billDetails .pulbic_pagesize {
			padding: 14px 18px;
			background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
		}

		.billDetails .pulbic_pagesize /deep/.el-pagination {
			font-weight: 700;
		}

		.billDetails .pulbic_pagesize /deep/.btn-prev,
		.billDetails .pulbic_pagesize /deep/.btn-next,
		.billDetails .pulbic_pagesize /deep/.el-pager li {
			border-radius: 8px;
		}

		.billDetails .pulbic_pagesize /deep/.el-pager li.active {
			background: var(--bill-primary);
			color: #ffffff;
		}
		@media screen and (max-width: 1440px) {
			.billDetails .public_statisticsInfo {
				grid-template-columns: repeat(2, minmax(0, 1fr));
			}
		}



		@media screen and (max-width: 1440px) {
			.billDetails .public_criteriaRange {
				grid-template-columns: repeat(2, minmax(240px, 1fr)) !important;
			}
		}

		@media screen and (max-width: 1100px) {
			.billDetails .public_criteriaRange {
				grid-template-columns: 1fr !important;
			}

			.billDetails-hero-main,
			.billDetails-section-head,
			.billDetails-table-head {
				align-items: flex-start;
				flex-direction: column;
			}

			.billDetails-filter-card .billDetails-section-head,
			.billDetails-filter-grid,
			.billDetails .public_operatArea {
				padding-left: 14px;
				padding-right: 14px;
			}

			.billDetails .public_operatArea_timePicker {
				max-width: none;
				min-width: 280px;
			}

			.billDetails .public_operatBtn {
				width: 100%;
				margin-left: 0;
			}

			.billDetails .public_saleWater_chaxun,
			.billDetails .public_saleWater_daochu {
				flex: 1;
			}
		}

		@media screen and (max-width: 768px) {
			.billDetails {
				gap: 12px;
				padding: 10px;
			}

			.billDetails-hero-main {
				padding: 18px 16px;
			}

			.billDetails-hero-meta {
				width: 100%;
				min-height: 72px;
			}

			.billDetails .public_singleMenu {
				grid-template-columns: 1fr;
				gap: 6px;
			}

			.billDetails .public_operatArea_timePicker {
				flex-basis: 100%;
				min-width: 0;
			}

			.billDetails-stat-panel,

			.billDetails .public_statistics,
			.billDetails .pulic_statistics_titlt,
			.billDetails .Amount,
			.billDetails .singular {
				min-width: 0;
			}

			.billDetails .pulic_statistics_titlt:first-child {
				overflow: hidden;
			}

			.billDetails .pulic_statistics_titlt:first-child .Amount {
				display: block;
				width: 100%;
				font-size: 26px;
				line-height: 32px;
				white-space: normal;
				overflow-wrap: anywhere;
				word-break: break-word;
			}

			.billDetails .pulic_statistics_titlt:last-child {
				align-items: center;
				flex-wrap: wrap;
				row-gap: 6px;
			}

			.billDetails .singular {
				max-width: 100%;
				white-space: normal;
				overflow-wrap: anywhere;
				word-break: break-word;
			}

			.billDetails-table-panel {
				padding: 12px;
			}

			.billDetails .public_statisticsInfo {
				grid-template-columns: 1fr;
			}

			.billDetails .pulbic_pagesize {
				justify-content: flex-start;
				overflow-x: auto;
			}
		}

		.billDetails-flow-table /deep/.el-table__fixed,
		.billDetails-flow-table /deep/.el-table__fixed-right {
			box-shadow: 10px 0 18px rgba(31, 115, 184, 0.08);
		}

		.billDetails-flow-table /deep/.el-table__fixed-right {
			box-shadow: -10px 0 18px rgba(31, 115, 184, 0.08);
		}

		.billDetails-flow-table /deep/.cell {
			line-height: 20px;
		}

		.billDetails-customer-cell {
			display: grid;
			gap: 4px;
			text-align: left;
		}

		.billDetails-customer-cell strong {
			color: var(--bill-strong);
			font-size: 13px;
			font-weight: 900;
			line-height: 18px;
		}

		.billDetails-customer-cell span {
			color: var(--bill-muted);
			font-size: 12px;
			line-height: 16px;
		}

		.billDetails-type-tag,
		.billDetails-channel-tag {
			display: inline-flex;
			align-items: center;
			justify-content: center;
			max-width: 100%;
			height: 28px;
			padding: 0 12px;
			border-radius: 10px;
			font-size: 12px;
			font-weight: 900;
			line-height: 28px;
			white-space: nowrap;
			box-sizing: border-box;
		}

		.billDetails-type-tag {
			border: 1px solid rgba(23, 139, 255, 0.22);
			background: linear-gradient(135deg, rgba(23, 139, 255, 0.12) 0%, rgba(8, 201, 138, 0.1) 100%);
			color: var(--bill-primary);
			box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.82);
		}

		.billDetails-channel-tag {
			border: 1px solid rgba(8, 185, 133, 0.2);
			background: linear-gradient(135deg, rgba(8, 185, 133, 0.12) 0%, rgba(23, 139, 255, 0.08) 100%);
			color: var(--bill-green);
			font-weight: 800;
		}

		.billDetails-money {
			display: inline-block;
			min-width: 76px;
			font-family: Microsoft YaHei, PingFang SC, sans-serif;
			font-weight: 900;
			line-height: 20px;
			text-align: right;
		}

		.billDetails-money.is-before {
			color: #627d98;
		}

		.billDetails-money.is-change {
			color: var(--bill-primary);
			font-size: 14px;
		}

		.billDetails-money.is-current {
			color: var(--bill-strong);
			font-size: 14px;
		}

		.billDetails-money.is-subsidy {
			color: var(--bill-green);
		}

		.billDetails-flow-table /deep/.el-table__body-wrapper {
			max-height: none !important;
			overflow-x: hidden !important;
			overflow-y: visible !important;
		}

		.billDetails-flow-table /deep/.el-table__fixed,
		.billDetails-flow-table /deep/.el-table__fixed-right {
			display: none !important;
		}

		.billDetails-flow-table /deep/.el-table__body td {
			padding: 10px 0;
			vertical-align: top;
		}

		.billDetails-main-cell {
			display: grid;
			gap: 4px;
			text-align: left;
		}

		.billDetails-main-cell strong {
			color: var(--bill-strong);
			font-size: 13px;
			font-weight: 900;
			line-height: 18px;
		}

		.billDetails-main-cell span {
			color: #334e68;
			font-size: 13px;
			font-weight: 800;
			line-height: 18px;
		}

		.billDetails-main-cell em {
			color: var(--bill-muted);
			font-size: 12px;
			font-style: normal;
			line-height: 16px;
		}

		.billDetails-tag-cell {
			display: flex;
			flex-wrap: wrap;
			align-items: center;
			gap: 8px;
		}

		.billDetails-money-stack,
		.billDetails-subtle-stack {
			display: grid;
			gap: 6px;
		}

		.billDetails-money-stack div,
		.billDetails-subtle-stack div {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 10px;
		}

		.billDetails-money-stack span,
		.billDetails-subtle-stack span {
			color: var(--bill-muted);
			font-size: 12px;
			line-height: 16px;
		}

		.billDetails-money-stack strong,
		.billDetails-subtle-stack strong {
			font-size: 13px;
			font-weight: 900;
			line-height: 18px;
		}

		.billDetails-money-stack .is-before {
			color: #627d98;
		}

		.billDetails-money-stack .is-change {
			color: var(--bill-primary);
		}

		.billDetails-money-stack .is-current,
		.billDetails-subtle-stack strong {
			color: var(--bill-strong);
		}

		.billDetails-remark-cell {
			display: grid;
			gap: 6px;
			text-align: left;
		}

		.billDetails-remark-cell p {
			display: -webkit-box;
			overflow: hidden;
			margin: 0;
			color: #334e68;
			font-size: 12px;
			line-height: 18px;
			text-overflow: ellipsis;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
		}

		.billDetails-remark-cell span {
			color: var(--bill-muted);
			font-size: 12px;
			line-height: 16px;
		}

		@media screen and (max-width: 1280px) {
			.billDetails-flow-table /deep/.el-table__header-wrapper,
			.billDetails-flow-table /deep/.el-table__body-wrapper,
			.billDetails-flow-table /deep/.el-table__body,
			.billDetails-flow-table /deep/.el-table__header {
				width: 100% !important;
			}
		}

		.billDetails-flow-table.is-relaxed /deep/.el-table__body td {
			padding: 16px 0;
			vertical-align: middle;
		}

		.billDetails-flow-table.is-relaxed /deep/.cell {
			line-height: 22px;
		}

		.billDetails-flow-table.is-relaxed /deep/.el-table__header-wrapper th {
			height: 40px;
			padding: 6px 0;
		}

		.billDetails-flow-table.is-relaxed /deep/.el-table__header-wrapper .cell {
			padding-left: 10px;
			padding-right: 10px;
			line-height: 18px;
		}

		.billDetails-main-cell.is-relaxed {
			gap: 7px;
			padding: 2px 0;
		}

		.billDetails-main-cell.is-relaxed strong {
			font-size: 15px;
			line-height: 20px;
		}

		.billDetails-main-cell.is-relaxed span {
			color: var(--bill-primary);
			font-size: 13px;
			font-weight: 800;
		}

		.billDetails-main-cell.is-relaxed em {
			font-size: 12px;
		}

		.billDetails-tag-cell.is-relaxed {
			gap: 8px;
			align-content: center;
		}

		.billDetails-money-card,
		.billDetails-extra-cell {
			padding: 10px 12px;
			border: 1px solid rgba(230, 239, 248, 0.95);
			border-radius: 14px;
			background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
		}

		.billDetails-money-card {
			display: grid;
			gap: 10px;
		}

		.billDetails-money-card-main,
		.billDetails-money-card-sub,
		.billDetails-extra-row {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 8px;
		}

		.billDetails-money-card-main span {
			color: var(--bill-muted);
			font-size: 12px;
			font-weight: 700;
		}

		.billDetails-money-card-main strong {
			color: var(--bill-primary);
			font-size: 20px;
			font-weight: 900;
			line-height: 24px;
		}

		.billDetails-money-card-sub {
			padding-top: 8px;
			border-top: 1px dashed rgba(220, 230, 242, 0.96);
		}

		.billDetails-money-card-sub span,
		.billDetails-extra-row span {
			color: var(--bill-muted);
			font-size: 12px;
			line-height: 16px;
		}

		.billDetails-extra-cell {
			display: grid;
			gap: 9px;
			text-align: left;
		}

		.billDetails-extra-row span {
			padding: 3px 8px;
			border-radius: 999px;
			background: #eef7ff;
		}

		.billDetails-empty {
			display: grid;
			justify-items: center;
			gap: 8px;
			padding: 38px 20px;
			color: var(--bill-muted);
		}

		.billDetails-empty strong {
			color: var(--bill-strong);
			font-size: 15px;
			font-weight: 900;
		}

		.billDetails-empty span {
			font-size: 13px;
			line-height: 20px;
		}

		.billDetails-extra-cell p {
			display: -webkit-box;
			overflow: hidden;
			margin: 0;
			color: #334e68;
			font-size: 13px;
			line-height: 20px;
			text-overflow: ellipsis;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2;
		}

		.billDetails-extra-cell em {
			color: var(--bill-muted);
			font-size: 12px;
			font-style: normal;
			line-height: 16px;
		}
</style>
